<template>
<div>

        <v-snackbar v-model="snackbar" top :timeout="2000">
        {{ snackbar_msg }}
        <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
                Close
            </v-btn>
        </template>
    </v-snackbar>

    <v-btn @click="open()" depressed color="teal" dark> Edit</v-btn>
    <v-dialog v-model="window" scrollable fullscreen>

        <v-card v-if="item" rounded="0">
            <v-card-title style="background-color:teal;color:#ffffff" class="pa-1">

                {{item.firstname}} {{item.lastname}}

                <v-spacer></v-spacer>
                <v-btn color="white" text @click="closeWindow" dark>
                    ปิด
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px;">

                <div class="row">
                    <div class="col-sm-6">
                        <v-card class="mx-auto mt-6" max-width="500" outlined>
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title class="text-h5 mb-1">
                                        {{item.title}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <div><b>CODE :</b> {{item.code}}</div>
                                    </v-list-item-subtitle>

                                    <v-list-item-subtitle>
                                        <div v-if="item.for_sale=='A'"><b>ขาย :</b> {{item.price}}</div>
                                        <div v-if="item.for_rent=='A'"><b>ให้เช่า :</b> {{item.price_rent}}</div>
                                    </v-list-item-subtitle>

                                </v-list-item-content>

                                <v-list-item-avatar tile size="80" color="grey"><img :src="item.picture"></v-list-item-avatar>
                            </v-list-item>

                        </v-card>

                        <v-card class="mx-auto mt-6 pa-5" max-width="500" outlined>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>ชื่อ - นามสกุล</b></div>
                                <div class="col-sm-9">{{item.firstname}} {{item.lastname}}</div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>อีเมล์</b></div>
                                <div class="col-sm-9">{{item.email}}</div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>เบอร์โทร</b></div>
                                <div class="col-sm-9">{{item.phone }}</div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>LINE</b></div>
                                <div class="col-sm-9">{{item.line}}</div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>งบประมาณ</b></div>
                                <div class="col-sm-9">{{item.budget}}</div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>ข้อความ</b></div>
                                <div class="col-sm-9" v-html="item.detail"></div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>วันที่</b></div>
                                <div class="col-sm-9">{{item.created}}</div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>อัปเดท</b></div>
                                <div class="col-sm-9">{{item.updated}}</div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-sm-3"><b>สถานะ</b></div>
                                <div class="col-sm-9">{{item.status_title}}</div>
                            </div>

                        </v-card>
                    </div>
                    <div class="col-sm-6" v-if="data">

                        <div class="row mt-4">

                            <div class="col-sm-12">
                                <v-autocomplete outlined v-if="status" v-model="data.c_status" :items="status" item-text="text" item-value="value" label="สถานะ"></v-autocomplete>

                                <div class="mt-2" v-if="data.c_status==6">
                                    <DatePick :value="data.date_6" title="วันที่เช่า" @setDate="setDate6" />

                                </div>
                                <div class="mt-2" v-if="data.c_status==7">
                                    <DatePick :value="data.date_7" title="วันที่จอง" @setDate="setDate7" />

                                </div>
                                <div class="mt-2" v-if="data.c_status==8">
                                    <DatePick :value="data.date_8" title="วันที่เตรียมเอกสารยื่นกู้" @setDate="setDate8" />

                                </div>
                                <div class="mt-2" v-if="data.c_status==9">
                                    <DatePick :value="data.date_9" title="วันที่โอน ปิดการขาย" @setDate="setDate9" />
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <v-autocomplete outlined v-if="media" v-model="data.c_media" :items="media" item-text="text" item-value="value" label="จากช่องทางสื่อ"></v-autocomplete>

                            </div>

                            <div class="col-sm-12">
                                <v-text-field v-model="data.sale_price" outlined name="input-7-6" label="ราคาขาย Sale"></v-text-field>
                            </div>

                            <div class="col-sm-12">
                                <v-textarea v-model="data.msg" outlined name="input-7-4" label="รายละเอียดความคืบหน้า"></v-textarea>
                            </div>

                            <div class="text-center col-sm-12">
                                <v-btn depressed color="primary" @click="updateStatus()">
                                    บันทึก
                                </v-btn>
                            </div>

                        </div>

                    </div>
                </div>

            </v-card-text>

        </v-card>
    </v-dialog>

</div>
</template>

<script>
import DatePick from '@/views/Register/DatePick'
export default {

    components: {
DatePick
    },
    props: {

        register_id: null,
    },

    data: () => ({
        window: null,
        media:null,
        status:null,
        item: null,
        data: null,
             snackbar: null,
        snackbar_msg: null,

    }),

    computed: {

    },

    watch: {

    },

    methods: {
        open() {

            this.getItem()
             this.getStatusList()

            this.window = true

        },

         setDate6(val) {
           this.data.date_6 = val

        },
           setDate7(val) {
           this.data.date_7 = val

        },
           setDate8(val) {
           this.data.date_8 = val

        },
          setDate9(val) {
           this.data.date_9 = val

        },

        updateStatus() {
            let $vm = this;

            this.snackbar_msg = null
            this.snackbar = null
   

            const formData = new FormData();
            formData.append("c_status", $vm.data.c_status);
            formData.append("c_media", $vm.data.c_media); 
            formData.append("msg", $vm.data.msg);
            formData.append("register_id", $vm.data.register_id);
            formData.append("sale_price", $vm.data.sale_price);

            formData.append("date_6", $vm.data.date_6);
            formData.append("date_7", $vm.data.date_7);
            formData.append("date_8", $vm.data.date_8);
            formData.append("date_9", $vm.data.date_9);

            var url = "register/setStatus?time=" + Math.random();
       
            this.$http
                .post(url, this.formData(formData))
                .then(function (res) {
                    console.log(res.data);

                    if (res.data.set_status == 'success') {
                
                        $vm.$emit('updateItem', true)
                    }

                    $vm.snackbar_msg = 'อัปเดทสถานะเรียบร้อยแล้วค่ะ'
                    $vm.snackbar = true
                  

                    if (res.data.set_detail == 'success') {
                    
                        $vm.detail = null
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getStatusList() {
            let url = "register/status";
            console.log(url)

            this.loading = true

            let $vm = this;
            this.$http
                .post(url, this.formData())
                .then(function (res) {
                    console.log(res.data);

                    $vm.status = Object.values(res.data.status)
                    $vm.media = Object.values(res.data.media)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },


        updateItem() {

            this.getItem();

            this.$emit('updateItem', true)
        },

        closeWindow() {
            this.window = false
            this.$emit('closeWindows', true)
        },

        getItem() {
            let url = "register/one?register_id=" + this.register_id;
            console.log(url)

            this.loading = true

            let $vm = this;
            this.$http
                .post(url, this.formData())
                .then(function (res) {
                    console.log(res.data);

                    $vm.loading = false
                    $vm.item = res.data.item
                    $vm.data = res.data.item
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
       

    },
    created() {

       

    },

};
</script>
